import { Skeleton } from '@frontend-workspace/react-shared-lib';

export function BronnoysundAdminSkeleton() {
  return (<>
    <div className='d-flex justify-content-end'>
      <Skeleton animation="wave" width={150} height={60} />
    </div>
    <Skeleton variant="rectangular" animation="wave" width='100%' height={850} />
  </>);
}

export default BronnoysundAdminSkeleton;
